module.exports = __webpack_public_path__ + "img/ncy-asnl-team.931097b.jpeg";